/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
import React from 'react';
import { GoogleApiWrapper, Map, InfoWindow, Marker } from 'google-maps-react';

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export class GMap extends React.Component {
  state = {
    showingInfoWindow: true,
    activeMarker: {},
    selectedPlace: {},
  };

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  }

  render() {
    const { longitud, latitud, google, markerName, gMapStyle } = this.props;
    return (
      <>
        <Map
          onClick={this.onMapClicked}
          containerStyle={containerStyle}
          styles={gMapStyle}
          google={google}
          zoom={15}
          initialCenter={{
            lat: latitud,
            lng: longitud,
          }}
        >
          <Marker
            position={{ lat: latitud, lng: longitud }}
            onClick={this.onMarkerClick}
            name={markerName}
            icon={{
              url: 'https://res.mundigea.com.ar/img/recursos/icon-map.png',
              anchor: new google.maps.Point(32, 32),
              scaledSize: new google.maps.Size(64, 64),
            }}
          />
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}
          >
            <div>
              <h5 style={{ marginBottom: 0 }}>{markerName}</h5>
            </div>
          </InfoWindow>
        </Map>
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (process.env.RAZZLE_GOOGLE_MAPS_API_KEY),
})(GMap);
